import { EAgencies } from "src/shared/types/common.types";
import {
  EPartnerPriority,
  EPartnerEasyService,
} from "src/shared/types/partner.types";

export const colorsByPartnerCategory: Record<EPartnerPriority, string> = {
  [EPartnerPriority.A]: "#ED7A96",
  [EPartnerPriority.B]: "#F9BAEB",
  [EPartnerPriority.C]: "#ECDE61",
  [EPartnerPriority.D]: "#F1C789",
  [EPartnerPriority.E]: "#42C461",
  [EPartnerPriority.N]: "#9CD0AD",
  [EPartnerPriority.VIP]: "#FC0D1B",
};

export const colorsByPartnersCompany: Record<EAgencies, string> = {
  [EAgencies.Webcom_BY]: "#c154ce",
  [EAgencies.Webcom_RU]: "#FF6600",
  [EAgencies.Webcom_KZ]: "white",
  [EAgencies.IContext]: "#00C6C3",
  [EAgencies.Digital]: "white",
};

export const colorsByEasyServiceType: Record<EPartnerEasyService, string> = {
  [EPartnerEasyService.Easy_service]: "#2c57b9",
  [EPartnerEasyService.Easy_service_ic]: "#00C6C3",
  [EPartnerEasyService.Disabled]: "white",
};
